import { z } from "zod";

/**
 * `McpServerTool.discoveredSchemaHash`, `McpServerTool.approvedSchemaHash` and
 * `AgentToolConfigMcpToolPin.pinnedSchemaHash`: SHA-256 as 64 lowercase hex
 * characters. The migration holds the three columns to the same pattern.
 *
 * How the hash is computed is `computeMcpToolSchemaHash` in `@nexus/types-server`.
 */
export const McpToolSchemaHashSchema = z.string().regex(/^[0-9a-f]{64}$/);

export type McpToolSchemaHash = z.infer<typeof McpToolSchemaHashSchema>;
